var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g2, _path50, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 215,
    viewBox: "0 0 443 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 190L49 157L358.5 165V187L369 190L284 207.5L217.5 203.5L131.5 207.5L111.5 203.5L87 199.813L45.5 190Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7747 129.076L71.8511 29.3622L72.9916 24.3694L191.318 51.9012L279.421 67.165L318.625 121.185L306.365 118.52L357.545 129.647V189.703L280.419 194.696L208.853 192.271L131.157 194.696L110.2 192.271L104.64 190.416H83.5411H76.1279L45.9048 187.278V167.449L44.0515 165.024V163.17L45.9048 161.886V149.475H42.7685V129.076H39.7747Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1362 31.6446L118.469 113.812L207.094 123.966V121.255L119.752 109.818L73.5618 28.3636L72.1362 31.6446Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.894 109.818L118.896 113.812",
    stroke: "#808080",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.051 122.086L280.134 67.1653L73.2767 26.2239L39.9172 128.933H43.909L74.7023 36.0669",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M128.163 133.926L207.094 140.334L207.805 190.15L128.163 192.271L105.923 189.846H100.934V136.922H105.923L128.163 133.926Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.115 129.647L279.421 113.67L207.805 121.119V126.112V190.305",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9089 128.933V149.333H52.7494V162.599H43.9089V164.454L45.3346 166.166V175.937V186.993",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3345 185.709L68.8572 187.421L74.5597 186.707L100.934 189.561L105.068 188.99L129.161 190.844L211.134 189.133L279.421 193.127L357.545 186.565V128.363",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3325 149.903V162.599",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4275 187.421L69.1423 86.423L93.0927 77.5786V130.075L73.2766 131.501L73.8469 186.707",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5474 82.1434V130.93",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9688 81.0022V130.93",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6753 129.932V84.9965L93.0927 83.5699",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5473 87.2789L76.1279 89.1334L76.6982 130.93",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.648 188.562V136.494L105.068 136.922L126.88 133.926L207.092 140.334V189.439",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.308 115.667V133.926",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.19 136.922V189.703",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M219.191 138.91H209.228V182.464L219.191 183.034V138.91Z",
    fill: "url(#paint2_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.874 135.353V190.416",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.718 137.487V190.839",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M250.339 184.425V136.922L263.454 136.779V184.996L250.339 184.425Z",
    fill: "url(#paint3_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.351 137.778V190.274",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.301 138.91V190.978",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M279.421 113.67V193.127",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.228 138.91H219.191V183.034L209.228 182.892",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M246.917 137.064V184.14L263.739 184.853V136.636L246.917 137.064Z",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250.624 136.922V184.282",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M305.225 182.571V139.49L345.998 143.769V180.145L305.225 182.571Z",
    fill: "url(#paint4_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M305.367 136.066V182.998L349.989 180.431V141.201L305.367 136.066Z",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M305.653 139.062L345.998 143.341L349.989 141.059",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M345.998 143.769V180.145",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M314.064 140.203V182.143",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M326.182 141.487V181.715",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M336.588 142.628V180.859",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5637 31.7872L118.896 113.669",
    stroke: "#808080"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.2705 130.788V88.9908L76.8408 88.4202L80.5474 87.1364V130.788H76.2705Z",
    fill: "url(#paint5_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M87.9604 130.217V85.2818L92.9501 83.9979V130.217H87.9604Z",
    fill: "url(#paint6_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M193.599 144.34L138.713 171.444V175.723L193.599 144.34Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M345.285 154.896L313.208 170.873V173.441L345.285 154.896Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.593 153.612L141.706 180.716V184.996L196.593 153.612Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M346.568 159.746L314.491 175.723V178.291L346.568 159.746Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M206.002 124.226L279.421 117.521L356.69 132.928",
    stroke: "#808080",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M94.0908 30.7888L128.306 91.4159L272.293 106.394L240.031 60.4095L94.0908 30.7888Z",
    fill: "#808080"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M368.724 188.586H357.782L284.523 195.133L216.346 191.148L134.504 192.856L110.45 191.005L106.323 191.575L79.991 188.728L74.2977 189.44L50.8128 187.732H30.6357",
    stroke: "#808080",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M102.512 0.0157819C101.631 -0.127361 100.898 0.731498 101.338 1.44721L122.909 41.5273L141.839 76.5974C142.133 77.3131 142.867 77.7425 143.6 77.7425L285.062 95.3491C285.942 95.4922 286.529 94.4902 286.089 93.7745L242.699 26.8979C242.699 26.8979 242.259 26.4685 241.966 26.4685L102.512 0.0157819Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M140.198 7.25281L180.762 81.9775",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M177.204 14.3695L217.769 87.6708",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M212.076 20.7744L253.352 93.3641",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M120.983 36.431L262.604 58.4926",
    stroke: "white",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.378 4C284.019 4 274 14.0191 274 26.3784C274 32.3841 276.366 37.8372 280.216 41.8567V53.1081L288.417 47.2992C290.891 48.241 293.574 48.7568 296.378 48.7568H297.622C309.981 48.7568 320 38.7376 320 26.3784C320 14.0191 309.981 4 297.622 4H296.378Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.378 4C284.019 4 274 14.0191 274 26.3784C274 32.3841 276.366 37.8372 280.216 41.8567V53.1081L288.417 47.2992C290.891 48.241 293.574 48.7568 296.378 48.7568H297.622C309.981 48.7568 320 38.7376 320 26.3784C320 14.0191 309.981 4 297.622 4H296.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.216 41.8567H281.216V41.455L280.938 41.1649L280.216 41.8567ZM280.216 53.1081H279.216V55.0419L280.794 53.9241L280.216 53.1081ZM288.417 47.2992L288.773 46.3646L288.274 46.1748L287.839 46.4832L288.417 47.2992ZM275 26.3784C275 14.5714 284.571 5 296.378 5V3C283.467 3 273 13.4669 273 26.3784H275ZM280.938 41.1649C277.259 37.3241 275 32.1161 275 26.3784H273C273 32.652 275.472 38.3503 279.494 42.5484L280.938 41.1649ZM281.216 53.1081V41.8567H279.216V53.1081H281.216ZM287.839 46.4832L279.638 52.2921L280.794 53.9241L288.995 48.1152L287.839 46.4832ZM296.378 47.7568C293.698 47.7568 291.135 47.2639 288.773 46.3646L288.061 48.2337C290.647 49.2181 293.451 49.7568 296.378 49.7568V47.7568ZM297.622 47.7568H296.378V49.7568H297.622V47.7568ZM319 26.3784C319 38.1853 309.429 47.7568 297.622 47.7568V49.7568C310.533 49.7568 321 39.2899 321 26.3784H319ZM297.622 5C309.429 5 319 14.5714 319 26.3784H321C321 13.4669 310.533 3 297.622 3V5ZM296.378 5H297.622V3H296.378V5Z",
    fill: "#DEDFE2",
    mask: "url(#path-51-inside-1)"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M294.404 29.112C294.413 27.7407 294.611 26.7426 294.996 26.1074C295.381 25.4722 296.151 24.7059 297.317 23.7985C297.998 23.2339 298.541 22.6188 298.946 21.9635C299.351 21.3081 299.558 20.5822 299.558 19.7655C299.558 18.8682 299.331 18.1624 298.867 17.6583C298.403 17.1542 297.741 16.892 296.882 16.892C296.171 16.892 295.579 17.1037 295.085 17.5373C294.591 17.9708 294.344 18.5959 294.334 19.4227H290.266L290.236 19.332C290.207 17.4566 290.809 16.0249 292.053 15.0268C293.288 14.0286 294.907 13.5345 296.892 13.5345C299.035 13.5345 300.713 14.0891 301.938 15.1982C303.153 16.3072 303.765 17.8095 303.765 19.7151C303.765 20.9552 303.409 22.1046 302.698 23.1532C301.987 24.2119 301.099 25.0891 300.022 25.8049C299.44 26.2687 299.055 26.7224 298.877 27.1862C298.699 27.65 298.6 28.2852 298.6 29.1019H294.404V29.112ZM298.61 35.1816H294.394V31.5217H298.61V35.1816Z",
    fill: "#404040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 38.5,
    y: 150,
    width: 337.5,
    height: 64.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 272,
    y: 2,
    width: 54,
    height: 57.1081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.055 0 0 0 0 0.114533 0 0 0 0 0.133333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 49,
    y1: 160,
    x2: 371.518,
    y2: 323.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 154.369,
    y1: 133.926,
    x2: 154.369,
    y2: 192.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 214.209,
    y1: 138.91,
    x2: 214.209,
    y2: 183.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 256.896,
    y1: 136.779,
    x2: 256.896,
    y2: 184.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 325.611,
    y1: 139.49,
    x2: 325.611,
    y2: 182.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 78.4089,
    y1: 87.1364,
    x2: 78.4089,
    y2: 130.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 90.4553,
    y1: 83.9979,
    x2: 90.4553,
    y2: 130.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeQuestionMark);
export default __webpack_public_path__ + "static/media/home-question-mark.9553ae4d86f6c3fd5a6520a08b3aec53.svg";
export { ForwardRef as ReactComponent };